// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bgw_a bhl_h","Menu__offsetParent":"bgw_b bhl_bj","Menu__trigger--shadowed":"bgw_c"};